const menu = [
  // Messaging Section
  {
    heading: "Messaging",
    admin: false,
  },
  {
    icon: "send",
    text: "Test Services",
    active: false,
    link: "/dashboard/test",
    keyWords: ["test", "api", "send", "send sms"],
    description: "Send a message now and test services.",
    admin: true,
  },
  {
    icon: "chat",
    text: "Chat App",
    link: "/dashboard/chat",
    active: false,
    keyWords: ["chat", "sms"],
    description: "View your sent messages in a chat-like interface.",
    admin: false,
  },
  {
    heading: "Integrations",
    admin: false,
  },
  {
    icon: "network",
    text: "API & Hooks",
    link: "/dashboard/api",
    active: false,
    keyWords: ["api", "integration", "development"],
    description: "Integrate our services using our robust API.",
    admin: false,
  },
   {
    icon: "puzzle",
    text: "GoHighLevel",
    link: "/dashboard/gohighlevel-setup",
    active: false,
    keyWords: ["api", "integration", "development"],
    description: "Integrate our services using our robust API.",
    admin: false,
  },
  
  // Devices Section
  {
    heading: "Account Management",
    admin: false,
  },
   {
    icon: "users",
    text: "Team",
    link: "/dashboard/team",
    active: false,
    keyWords: ["team", "management"],
    description: "Manage your team members.",
    admin: true,
  },
  {
    icon: "text-rich",
    text: "Account",
    link: "/dashboard/user",
    active: false,
    keyWords: ["account", "profile"],
    description: "Access your account details and settings.",
    admin: false,
  },
  
  {
    icon: "line-chart-up",
    text: "Balance and Analytics",
    active: false,
    link: "/dashboard/analytics",
    keyWords: ["analytics", "statistics", "usage"],
    description: "Analyze your service usage and performance.",
    admin: false,
  },
  {
    heading: "Resources",
    admin: false,
  },
  // Integration Section

  {
    icon: "video",
    text: "Tutorials",
    link: "/dashboard/tutorials",
    active: false,
    keyWords: ["api", "integration", "development", "tutorials", "tutorial"],
    description: "Step by step guides",
    admin: false,
  },

  
  // Account Section
  

];

export default menu;
